export function formatValue(
  balance: string,
  includeDecimals = true,
  includeCurrencySymbol = true
): string {
  const numBalance = Number(balance)

  if (isNaN(numBalance)) {
    return balance
  }

  const isNegative = numBalance < 0
  const absValue = Math.abs(numBalance)

  const formattedValue = absValue.toLocaleString('en-US', {
    minimumFractionDigits: includeDecimals ? 2 : 0,
    maximumFractionDigits: includeDecimals ? 2 : 0
  })


  const currencyValue = isNegative
    ? `-$${formattedValue}`
    : `$${formattedValue}`

  return includeCurrencySymbol ? currencyValue : formattedValue
}
